import { render, staticRenderFns } from "./VerDetalleCalendarioModal.vue?vue&type=template&id=6e944e57&"
import script from "./VerDetalleCalendarioModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleCalendarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports